var addition_constant = 0;
var onscrolleventbackup;
var onscrolleventbackup_home;
var onscrolleventbackup_header;

$(document).ready(function () {
	//verifica email messaggio
	let emailVerified = findGetParameter('email_verified');
	if(emailVerified){
		if(emailVerified=='success'){
			open_notifications_toast(translate('SUCCESS_ACTIVATION'), "#008000");
		}
		if(emailVerified=='error'){
			open_notifications_toast(translate('ERROR_ACTIVATION'), "#FF0000");
		}
		if(emailVerified=='user_already_verified'){
			open_notifications_toast(translate('ALREADY_ACTIVE_ACCOUNT'), "#FF0000");
		}
	}
	///
});


function setSavedContent(id, type, playlistId = null) {
    if (userData.status == "success") {
        $(".reminder_" + type + id).html('<i class="ri-loader-4-line fx-spin"></i>');
        $.ajax({
            type: "POST",
            url: URL_API + "/video/?f=set_saved",
            cache: false,
            data: "id=" + id + "&type=" + type + (playlistId ? "&playlist_id=" + playlistId : ""),
            success: function (html) {
				var obj = JSON.parse(html);
					
				if (!playlistId) {
					playlistId = 0;
				}
					
				if (type == 'serie') {
					if (obj[0].status == 'saved_removed') {
						var index = userData.playlists[playlistId].collections.indexOf(id);
						if (index !== -1) {
							userData.playlists[playlistId].collections.splice(index, 1);
						}
					} else {
						if (!userData.playlists[playlistId].collections.includes(id)) {
							userData.playlists[playlistId].collections.push(id);
						}
					}
				}
				if (type == 'video') {
					if (obj[0].status == 'saved_removed') {
						var index = userData.playlists[playlistId].videos.indexOf(id);
						if (index !== -1) {
							userData.playlists[playlistId].videos.splice(index, 1);
						}
					} else {
						if (!userData.playlists[playlistId].videos.includes(id)) {
							userData.playlists[playlistId].videos.push(id);
						}
					}
				}
				
				
				checkIfContentIsSaved(id, type);
				
				clearLocalStorageKeys('?option=saved');
			}
        });
    } else {
        window.location.replace("/register");
    }
}

var lastIdContentPlaylistToSave=null;
var lastTypeContentPlaylistToSave=null;
function openModalSetSavedContent(idContent, typeContent, back=false) {

	if (userData.status == "success") {

        lastIdContentPlaylistToSave = idContent;
        lastTypeContentPlaylistToSave = typeContent;
        // Controlla se il modal esiste già e rimuovilo se esiste

        // Ottieni le playlist dell'utente e genera l'HTML per il modal
        getUserPlaylist(true).then(playlists => {
            let html = '';
            let isChecked = false; // Variabile per verificare se almeno una checkbox è selezionata

            // Trova le playlist che contengono il contenuto
            const selectedPlaylists = findContentInPlaylists(idContent, typeContent).map(playlist => playlist.id);

            Object.entries(playlists).forEach(([index, playlist]) => {
                // Verifica se il contenuto è già presente nella playlist
                const isCheckedPlaylist = selectedPlaylists.includes(index);

                // Imposta isChecked a true se almeno una checkbox è selezionata
                if (isCheckedPlaylist) {
                    isChecked = true;
                }


                // Costruisci l'HTML per ogni checkbox, impostando checked se il contenuto è nella playlist
                // playlist 0 = preferiti di default: cuore, le altre icona lista
                html += `
                    <div class="container-box-flex">
                        <label class="checkbox style-e">
                            <input name="checkbox-playlist-${index}" id="checkbox-playlist-${index}"
                                value="${index}" onchange="setSavedContent(${idContent},'${typeContent}', ${index});" type="checkbox" ${isCheckedPlaylist ? 'checked' : ''}>
                            <i class="${String(index) === '0' ? 'ri-heart-line' : 'ri-play-list-line'} settings-icon"></i>
                            <div class="checkbox__body white"> ${playlist.title} ${!playlist.public ? '<i class="ri-lock-line"></i>' : ''}</div>
                            <div class="checkbox__checkmark"></div>
                        </label>
                    </div>
                `;
            });

            // Lista come le impostazioni del profilo: una card, "crea" come ultima riga
            $('#modal-body-generic').html(`
                <div class="ty-pl-save">
                    <form id="mainPlaylist_list" class="ty-pl-save-list">
                        ${html}
                    </form>
                    <button type="button" class="ty-pl-save-create" onclick="initCreatePlaylist(null, true);">
                        <span class="settings-icon"><i class="ri-add-line"></i></span> ${translate('CREATE_NEW_PLAYLIST')}
                    </button>
                </div>
            `);

            if(back==false){
                BSLight.ModalShow('#modal-generic');
                addPageToState('modal-generic');
            }

            // Se nessuna checkbox è selezionata, chiama la funzione firstPlaylistCheck
            if (!isChecked) {
                //firstPlaylistCheck();
                $('#checkbox-playlist-0').attr('checked','checked');
                setSavedContent(idContent, typeContent, 0);
            }

        });
    }else{
        openModalLogin();
    }
}


function findContentInPlaylists(id, type) {
    const results = [];

    if (typeof userData !== 'undefined' && userData.status !== undefined && userData.playlists) {
        for (const playlistId in userData.playlists) {
            const playlist = userData.playlists[playlistId];
            
            if (type === 'serie' && Array.isArray(playlist.collections) && playlist.collections.includes(id)) {
                results.push({
                    id: playlistId,
                    title: playlist.title
                });
            }
            
            if (type === 'video' && Array.isArray(playlist.videos) && playlist.videos.includes(id)) {
                results.push({
                    id: playlistId,
                    title: playlist.title
                });
            }
        }
    }

    return results;
}

function getUserPlaylist(isMine = false) {
    return new Promise((resolve) => {
        const checkUserDataStatus = () => {
            if (typeof userData !== 'undefined' && userData && userData.status !== undefined) {
                clearInterval(intervalIdPlaylists);
                try {
					let filteredPlaylists = userData.playlists;
                    if (isMine) {
                        filteredPlaylists = filteredPlaylists.filter(playlist => playlist.id_parent === undefined || playlist.id_parent === null);
                    }
                    const firstElement = filteredPlaylists[0];
                    const sortedPlaylists = filteredPlaylists
                        .slice(1)
                        .sort((a, b) => (filteredPlaylists.indexOf(b) - filteredPlaylists.indexOf(a)));

                    const finalPlaylists = [firstElement, ...sortedPlaylists];
                    resolve(finalPlaylists);
				} catch (error) {
					resolve(userData.playlists);

				}
            }
        };

        const intervalIdPlaylists = setInterval(checkUserDataStatus, 100);
    });
}

function clearLocalStorageKeys(val) {
    for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key.includes(val)) {
            localStorage.removeItem(key);
        }
    }
}

function setLikeLive(id, type) {
    // alert(1);
	if (userData.status == "success") {
		$.ajax({
			type: "POST",
			url: URL_API + "/video/?f=set_likes",
			cache: false,
			data: "id=" + id,
			success: function (html) {
				if (html) {
					var obj = JSON.parse(html);
					var likes_tot = obj[0].tot_likes;

					if(obj[0].status == "likes_add"){
						userData.liked.push(id);
					}else{
						var index = userData.liked.indexOf(id);
						if (index !== -1) {
							userData.liked.splice(index, 1);
						}
					}
					checkIfContentIsLiked(id, type, likes_tot);
				}
			}
		});
		return false;
	} else {
		openModalLogin();
	}

}

// $(".bg_live_nex").mouseover(function() {
//   alert("ok");
// });



var checkNoResLiveInLive = 0; //fix

var sliderLoadercheck = 0;
var sliderLoadercheckVideo = 0;

var currentStepLiveInLive = 1;
var semapWindowsScrollLiL = 0;

function getLiveInLive(urlapi, divLiveInLive, idRequest) { // Videos

	var position = getUrlParameter("position", urlapi);

	if (position != undefined && position != null) {
		var pos = position;
	} else {
		var pos = "";
	}

	if (getUrlParameter("page", urlapi) == 1 && getUrlParameter("append", urlapi) != 1) {
		currentStepLiveInLive = 1;
		semapWindowsScrollLiL = 0;
		$(divLiveInLive).html('');
	}

	$(divLiveInLive).append('<div id="loading_results_spinner" class="col-md-12 text-center row"><svg id="" class="circularLoading" height="50" width="50"><circle class="path" cx="25" cy="25.2" r="19.9" fill="none" stroke-width="6" stroke-miterlimit="10" /></svg></div>');
    
	$.ajax({
		localCache: true,
		cacheTTL: 0.5,
		type: "GET",
		url: urlapi,
		success: function (html) {
			$("#loading_results_spinner").remove();
			var objJson = JSON.parse(html);

			if (objJson.length == 0 && getUrlParameter("page", urlapi) == 1 && getUrlParameter("append", urlapi) != 1) {

				$(divLiveInLive).html("<p class='white bold text-center'>" + translate("NO_RESULTS") + "</p>");

			} else {

				if (objJson.length < 8) {
					$(".searchSpecificLoadMore").hide();
				}

				for (var i = 0; i < objJson.length; i++) {
					var img_preview = objJson[i].img_preview;
					if (img_preview == "") {
						img_preview = "/img/no_live_preview.jpg";
					}
					var detailsHtml = "";
					var percentView = "";
					var type_content = 'serie';

					var urlapi2 = urlapi.substr(0, urlapi.indexOf("?"));

					if (urlapi2.toLowerCase().indexOf("collection") >= 0) {
						var series_price_and_subscription = "";
						var priceHtml = "";
						var htmlSubsFreeAccess = "";
						var htmlOr = "";
						var urlSeries = "";

						if (objJson[i].payment_type == "fixed" || objJson[i].payment_type == "fixed_and_subs") {
							priceHtml = '<span class="teyuto_price">' + objJson[i].price + "€</span>";
						}

						if (objJson[i].payment_type == "fixed_and_subs") {
							htmlOr = translate("OR");
						}
						if (objJson[i].payment_type == "subs" || objJson[i].payment_type == "fixed_and_subs") {
							htmlSubsFreeAccess = translate("AVAILABLE_ON_SUBSCRIPTION");
						}

						if (objJson[i].payment_type != "" && objJson[i].payment_type != null) {
							series_price_and_subscription =
								'<span class="label_teyuto_price">' +
								priceHtml +
								" " +
								htmlOr +
								" " +
								htmlSubsFreeAccess +
								"</span>";
							detailsHtml =
								"<div class='details'>" +
								series_price_and_subscription +
								"</div>";
						}

						var counterVideo = "";
						if (objJson[i].nvideo > 1) {
							counterVideo = '<span class="counter-video-series counter-video-seriesLiveInLive"><i class="ri-play-circle-line"></i> ' + objJson[i].nvideo + '</span>';
						}

						var extra_dots = "";
						var title = objJson[i].title;
						if (title.length > 60) {
							extra_dots = "...";
						}

						if (objJson[i].access == 'ok' || objJson[i].access == 'preview' || objJson[i].access == 'not_paid') {
							if (objJson[i].parent) {
								urlSeries = "window.location = \'../../../package?s=" + objJson[i].display_name + "\';";
							} else {
								urlSeries = "openSerieThumb(" + objJson[i].id + ")";
							}
						} else {
							urlSeries = "noAccessFunction();"
						}

						let lastSeen = getVideoLastSeen(objJson[i].id, null);

						//console.log(objJson[i].title+" serie 1");
						var html = `<div class="col-sm-3 col-xs-6 thumb_content_preview mb-3">
                            <div>
                                <div class="tile tile__box" onclick="${urlSeries}">
                                    <div class="tile__media">${counterVideo}<img onerror="this.onerror=null;this.src='img/void1px.png';" loading="lazy" src="${img_preview}"></div>
                                    <div class="tile__details_serie">${detailsHtml}</div>
                                </div>
                            </div>
                            <div class="percentVideoProgress" style="width:'${lastSeen}%;"></div>
                            <div class="tile__title" onclick="${urlSeries}">${objJson[i].title.substring(0, 60)}${extra_dots}</div>
                        </div>`;

					} else {
						type_content = 'video';
						var duration = "";
						var type = "";
						var splittedHour = "";

						if (objJson[i].subscribe == 1) {
							subscribe = "<i class='ri-lock-fill'></i>";
						} else {
							subscribe = "";
						}

						if (objJson[i].ondemand == 1) {
							if (objJson[i].upload == 1) {
								type = "";
							}
							if (objJson[i].quiz == 1) {
								type = "Quiz";
							}

							if (objJson[i].upload != 1) {
								type = "Live";
							}

							duration = objJson[i].duration;
							if (duration) {
							} else {
								duration = "";
							}
						} else {
							if (objJson[i].upload != 1) {
								type = 'Live';
							}
						}

						detailsHtml =
							"<div class='detailsTypeVideo' ><span>" + type + "</span><span>  " + duration + "</span></div>";


						if (objJson[i].percentView >= 100) {
							percentView = 100;
						} else {
							percentView = objJson[i].percentView;
						}

						var title = objJson[i].title.substring(0, 100);

						//console.log(objJson[i].title+" video 1");
						let lastSeen = getVideoLastSeen(null, objJson[i].id);

						var html = '<div class="col-sm-3 thumb_content_preview mb-3">' +
							'<div class="tile tile__box" onclick="loadPageVideo('+objJson[i].id+');">' +
							'<div class="tile__media"><img loading="lazy" src="' + img_preview + '"></div>' +
							detailsHtml +
							'</div>' +
							'<div  onclick="loadPageVideo('+objJson[i].id+');" class="tile__title">' + title + '</div>' +
							'</div> '+
                            '<div class="percentVideoProgress" style="width:' + lastSeen + '%;"></div>'+
                            '</div>';

					}

					$(divLiveInLive).append(html);
                    checkIfContentIsSaved(objJson[i].id, type_content);
				}


				if (objJson.length > 8) {

					semapWindowsScrollLiL = 0;
					if (getUrlParameter("page", urlapi) == 1) {

						var lastScrollTop = 0;

						$(window).off('scroll');

						$(window).scroll(function () {
							var st = $(this).scrollTop();

							if (semapWindowsScrollLiL == 0 && st > lastScrollTop && $(window).scrollTop() + $(window).height() > $(document).height() - 400) {
								currentStepLiveInLive++;
								var urlapi2 = replaceUrlParam(urlapi, "step", currentStepLiveInLive);
								getLiveInLive(urlapi2, divLiveInLive, idRequest);
								semapWindowsScrollLiL = 1;
							}

							lastScrollTop = st;

						});


					}

				}




			}


		}
	});
}



var currentStepLiveInLive1 = 1;
var currentStepLiveInLive2 = 1;
var semapWindowsScrollLiL2 = 0;
var semapWindowsScrollLiL1 = 0;

function getLiveInLive2(urlapi, divLiveInLive2) { // Collections

	if ((getUrlParameter("page", urlapi) == 1 || getUrlParameter("step", urlapi) == 1) && getUrlParameter("append", urlapi) != 1) {
		currentStepLiveInLive2 = 1;
		currentStepLiveInLive1 = 1;
		semapWindowsScrollLiL2 = 0;
		semapWindowsScrollLiL1 = 0;
		$(divLiveInLive2).html('');
	}

	$(divLiveInLive2).append('<div id="loading_results_spinner" class="col-md-12 text-center row"><svg id="" class="circularLoading" height="50" width="50"><circle class="path" cx="25" cy="25.2" r="19.9" fill="none" stroke-width="6" stroke-miterlimit="10" /></svg></div>');

	$.ajax({
		url: urlapi,
		localCache: true,
		cacheTTL: 0.5,
		success: function (res) {

			$("#loading_results_spinner").remove();

			var objJson = JSON.parse(res);
            // console.log(JSON.stringify(objJson));
            //compantibiliy with contents
			if(objJson.contents){
				objJson = objJson.contents;
			}

			// gestione tab della COLLECTION (episodi/correlati): SOLO quando
			// si renderizza la lista episodi della collection — applicata a
			// qualsiasi target faceva sparire le playlist con 0-1 elementi
			if (divLiveInLive2 === '#mainLive') {
				if (objJson.length > 1) {
					$('.selectNavigationCollectionEpisodes').show();
					$('.selectNavigationCollectionRelated').removeClass('active');
					$('.video_episodes').show();
					$('.video_related_contents').hide();
				} else {
					if (getUrlParameter("step", urlapi) == 1 || getUrlParameter("page", urlapi) == 1) {
						$('.selectNavigationCollectionEpisodes').hide();
						$('.selectNavigationCollectionRelated').addClass('active');
						$('.video_episodes').hide();
						$('.video_related_contents').show();
						return false;
					}
				}
			}

			// playlist/preferiti vuoti: stato dedicato con CTA verso la home
			if (objJson.length === 0 && (divLiveInLive2 === '#mainLiveHomePlaylistResults' || divLiveInLive2 === '#playlistPageContents')
				&& (getUrlParameter("step", urlapi) == 1 || getUrlParameter("page", urlapi) == 1)) {
				var tEmpty = translate('NO_FAVORITES_IN_PLAYLIST');
				if (tEmpty === 'NO_FAVORITES_IN_PLAYLIST') { tEmpty = 'Nessun preferito in questa playlist'; }
				var tBrowse = translate('BROWSE_CATALOG');
				if (tBrowse === 'BROWSE_CATALOG') { tBrowse = 'Naviga il catalogo'; }
				$(divLiveInLive2).html(
					'<div class="playlist-empty-state">' +
						'<i class="ri-heart-line"></i>' +
						'<p class="white">' + tEmpty + '</p>' +
						'<button class="button-primary" onclick="navigateToPage(\'home\');">' + tBrowse + '</button>' +
					'</div>');
				return false;
			}

			for (var i = 0; i < objJson.length; i++) {

				if (objJson[i].subscribe == 1) {
					subscribe = "<i class='ri-lock-fill'></i>";
				} else {
					subscribe = "";
				}

				var duration = "";
				var type = "";
				let typeClass = '';
				duration = objJson[i].duration;
                if(objJson[i].type_element == 'live'){
                    type = translate('LIVE');
                    duration='';
                }
				if (objJson[i].livenow == '1') {
					typeClass = 'live-vertical-livenow-label';
				}

                if(objJson[i].type_content == 'collections'){
					type = '';
					duration = '<i class="ri-play-circle-fill"></i> ' + objJson[i].duration;
				}

				detailsHtml = `
                <div class='detailsTypeVideoLiveInLive'>
                    ${type ? `<span class='${typeClass}'>${type}</span>` : ""}
                    ${duration ? `<span class='gray'>${duration}</span>` : ""}
                </div>
                `;
                
                //non è possibile scaricare le collections, devi per forza entraci
                if((objJson[i].type_element != 'live' && objJson[i].type_content == 'collections')){
                    detailsHtml += `
                        ${(listDownloadedVideosIds.includes(objJson[i].id)) ? `
                            <button class="button-round controlButtonShare mr-1 downloadedVideo-${objJson[i].id}">
                                <i class="ri-check-line font-size-16"></i>
                            </button>
                        ` : `
                            <button onclick="event.preventDefault();event.stopPropagation();startDownloadContentBatch('${objJson[i].id}'); " class="button-round controlButtonShare mr-1 downloadedVideo-${objJson[i].id}">
                                <i class="ri-download-2-line font-size-16"></i>
                            </button>
                        `}
                    `;
                }
                
                let contentToSave = (objJson[i].type_content == 'videos') ? 'video' : 'serie';
				detailsHtml += `<button onclick="event.stopPropagation();openModalSetSavedContent(${objJson[i].id},'${contentToSave}');" class="button-round reminder_${contentToSave}${objJson[i].id}"></button>`;
                
                detailsHtml += '</div>';

				if (objJson[i].percentView >= 100) {
					percentView = 100;
				} else {
					percentView = objJson[i].percentView;
				}


                var reminder_obj= '';
				var like_obj = '';
				var views_obj = '';
				var tot_views = 0;
				var div_like_views = '';

				img_preview = objJson[i].img_preview;
                //compantibily with contents
				if(objJson[i].image){
					img_preview = objJson[i].image;
				}

				if (objJson[i].category) {
					category = "#" + objJson[i].category;
				} else {
					category = "";
				}

				// if (objJson[i].show_likes && companyShowLikeVideo) {
				// 	like_obj = '<div tooltip="' + translate('LIKE_IT') + '" flow="right" onclick="event.stopPropagation();setLikeLive(' + objJson[i].id + ', \'all_scr\');" class="div-likes like' + objJson[i].id + '"></div>';
				// }

				tot_views = formatVideoViews(objJson[i].views);
                if ((companyShowVideoViewThumb == 1 || companyShowVideoViewThumb == true)) {
                    views_obj = '<div class="div-views"><span>' + tot_views + ' ' + translate('VIEWS') + '</span></div>';
                    div_like_views = '<div class="box-like-views">' +views_obj + '</div>';
                }

				var div_lock = '';
				var label_courses = '';
				var classOpacity = '';
				var progressPercent = 0;
				// var serieIsE = $('#seriesIsEnabled').val();

				// if (objJson[i].isCourse == 1) {
				// 	if (objJson[i].progress_percent > 0) {
				// 		progressPercent = parseInt(objJson[i].progress_percent);
				// 	}

				// 	if (progressPercent < 40) {
				// 		label_courses = 'label-danger';
				// 	} else if (progressPercent < 80) {
				// 		label_courses = 'label-warning';
				// 	} else {
				// 		label_courses = 'label-success';
				// 	}

				// 	if ((objJson[i].isEnabled == 0 || serieIsE == '0') && i != 0) {
				// 		div_lock = '<div class="course-progress-iconLiL2"><i class="ri-lock-fill"></i></div>';
				// 		var classOpacity = 'tile_details_opacity';
				// 	} else {
				// 		div_lock = '<div class="course-progress-iconLiL2"><span class="label ' + label_courses + '">' + progressPercent + '%</span></div>';
				// 	}
				// }

				var extra_dots_desc = "";
				var description = objJson[i].description;
				if (description.length > 195) {
					extra_dots_desc = "...";
				}

				let lastSeen = 0;
                var onclickFunc = `loadPageVideo(${objJson[i].id});`;
				if(objJson[i].type_content == 'collections'){
					onclickFunc = `openSerieThumb(${objJson[i].id});`;
                    lastSeen = getVideoLastSeen(objJson[i].id, null);
				}else{
                    lastSeen = getVideoLastSeen(null, objJson[i].id);
                }
                
                // var html = `
                // <div class="playlist-item">
				// 	<div class="playlist-item-image-container">
                //         <img onerror="this.onerror=null;this.src='img/void1px.png';" src="${img_preview}">
                //     </div>                 
                //     <div class="playlist-item-info">
                //         <div class="playlist-item-title">${objJson[i].title}</div>
                //         <div class="playlist-item-artist">${div_like_views}</div>
                //     </div>
                //     <div class="playlist-item-duration">5:55</div>
                //     <div class="playlist-item-actions">
                //         ${detailsHtml}
                //     </div>
                //     <div class="percentVideoProgress" style="width:${lastSeen}%;"></div>
                // </div>
                // `;

				var html = `<div onclick="${onclickFunc}" class="col-sm-12 padding-0 box-element-video">
                        ${div_lock}
                        <div class="col-sm-5 img-container-vertical-list-video padding-0">
                            <div class="tile__box">
                                <div class="tile__media_vertical">
                                    <img onerror="this.onerror=null;this.src='img/void1px.png';" loading="lazy" src="${img_preview}">
                                </div>
                            </div>
                            <div class="percentVideoProgress" style="width:${lastSeen}%;"></div>
                        </div>
                        <div class="col-sm-7 box-element-video-details-info pa-1">
                            <p class="white bold box-title-video">${objJson[i].title.substring(0, 150)}</p>
                            ${detailsHtml}
                            ${div_like_views}
                        </div>
                    </div>
                    `;

				$(divLiveInLive2).append(html);
                // if(companyShowLikeVideo){
				// 	checkIfContentIsLiked(objJson[i].id, 'all_scr', objJson[i].total_likes);
				// }
				checkIfContentIsSaved(objJson[i].id, contentToSave);
			}


			if (objJson.length > 8) {
                semapWindowsScrollLiL2 = 0;

                let sentinelParent = document.querySelector(divLiveInLive2);
                if ((getUrlParameter("page", urlapi) == 1 || getUrlParameter("step", urlapi) == 1) && sentinelParent) {
                    // Creiamo un elemento sentinella da osservare, in coda
                    // alla lista dei risultati (pagina collection/playlist:
                    // lo scroll è quello della finestra, non più della modal).
                    // sentinelParent può mancare se nel frattempo si è
                    // navigato altrove (la pagina contenuto viene svuotata)
                    let oldSentinel = document.getElementById('sentinel');
                    if (oldSentinel) { oldSentinel.remove(); }
                    let sentinel = document.createElement('div');
                    sentinel.id = 'sentinel';
                    sentinelParent.appendChild(sentinel);

                    let observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                if ((currentPageState[currentPageState.length-1].indexOf("collection") !== -1 || 
                                    currentPageState[currentPageState.length-1].indexOf("playlist") !== -1) && 
                                    semapWindowsScrollLiL2 == 0) {
                                    
                                    currentStepLiveInLive1++;
                                    var urlapi2 = replaceUrlParam(urlapi, "step", currentStepLiveInLive1);
                                    urlapi2 = replaceUrlParam(urlapi2, "page", currentStepLiveInLive1);
                                    getLiveInLive2(urlapi2, divLiveInLive2);
                                    semapWindowsScrollLiL2 = 1;

                                    // Disconnettiamo l'observer dopo aver caricato nuovi contenuti
                                    observer.disconnect();
                                }
                            }
                        });
                    }, {
                        root: null, // viewport: le pagine scorrono con la finestra
                        rootMargin: '0px 0px 200px 0px', // Equivalente al -200 nel tuo codice originale
                        threshold: 0.1
                    });

                    // Iniziamo ad osservare il sentinel
                    observer.observe(sentinel);
                }
            } else {
                // Non c'è bisogno di rimuovere gli event listener, poiché non li stiamo più usando
            }
		},
        complete: function(){
          $('#loading_results_spinner').remove();
        }
	});
}



function noAccessFunction() {
	open_notifications_toast(translate('YOU_CANNOT_ACCESS_TO_THIS_CONTENT'), 'rgba(192, 57, 43, 1)');
}


var slickBreakpointDefault = 5;

var slickBreakpointLarge = 4;
var slickBreakpointMid = 2;
var slickBreakpointSmall = 1;

var slickBreakpointWidthLarge = 1220;
var slickBreakpointWidthMid = 720;
var slickBreakpointWidthSmall = 340;

function getCurrentBreakpoint() {
	let moduleStep = slickBreakpointDefault;
	if ($(window).width() <= slickBreakpointWidthLarge) {
		moduleStep = slickBreakpointLarge;
	}

	if ($(window).width() <= slickBreakpointWidthMid) {
		moduleStep = slickBreakpointMid;
	}

	if ($(window).width() <= slickBreakpointWidthSmall) {
		moduleStep = slickBreakpointSmall;
	}

	return moduleStep;
}



function showPreviewContentPopUp(obj) {
	// console.log(obj);
}





let volumeGeneralHomeMuted = true;



function temporaryVolumeThumbs() {

	$('.thumb_content_preview_trailer iframe').contents().find('video').each(function () {
		let videoCurrent = $(this)[0];
		if (volumeGeneralHomeMuted == false) {
			videoCurrent.muted = false;
		} else {
			videoCurrent.muted = true;
		}
	});

}


function temporaryMutedSlideshow(mode) {

	$('.slide-visible iframe').contents().find('video').each(function () {
		let videoCurrent = $(this)[0];
		if (mode == "muted") {
			// console.log("muto slideshow");
			// volumeGeneralHomeMuted = true;
			videoCurrent.muted = true;
		} else {
			// console.log(volumeGeneralHomeMuted);
			if (volumeGeneralHomeMuted == false) {
				// console.log("volume al slideshow");
				// volumeGeneralHomeMuted = false;
				videoCurrent.muted = false;
			}
		}
	});

}




let swiffyEndLoadMore = [];

function getContentsHorizontal(url, page, pos, mode = null, numbered = null, cover = null, currentVideoId = null) {

	// alert(currentVideoId);
	sliderLoadercheckVideo = 1;

	// let urlSplit = url.split("?");
	// // ? START override calls to get_video and get_collection
	// if (url.includes("get_video")) {
	// 	url = URL_API2 + "/contents/videos";
	// } else if (url.includes("get_collection")) {
	// 	url = URL_API2 + "/contents/collections";
	// } else {
	// 	url = URL_API2 + "/contents";
	// }

	// let queryStrings = urlSplit[1];
	// if (!!queryStrings && queryStrings != '') {
	// 	url += '?' + queryStrings;
	// }
	// ? END override calls to get_video and get_collection


	if (!(Number.isInteger(page))) { // step
		page = 1;
	}

	let subcategory = getUrlParameter("subcategory", url);
	let finalArray = [];
	let img_preview = '';
	let category = '';
	let duration = "";
	let type = "";
	let detailsHtml = "";
	let percentView = '';
	let tot_likes = 0;
	let div_lock = '';
	let progressPercent = 0;
	let classOpacity = 'tile_details_opacity';
	let like_obj = '';
	let views_obj = '';
	let tot_views = 0;
	let div_like_views = '';
	let extra_dots = "";
	let title = "";
	let splittedHour = '';
	let splittedDuration = '';


	let k_number = 0;
	if (page == 1) {

		let modeHtml = "responsive-slide-movie";
		if (mode == "featured") {
			modeHtml = "responsive-slide-movie-featured";
		}

		$(pos + " .liveHorizontalListVideo").html(`
		<div class="
		swiffy-slider ${modeHtml} slider-item-snapstart slider-item-${cover} slider-nav-noloop slider-nav-sm slider-nav-autohide slider-nav-page">
        <ul class="slider-container">
		</ul>
		</div>`);

	} else {
		k_number = 9 * (page - 1);
	}
	if (isNaN(subcategory)) {
		url = replaceUrlParam(url, "subcategory", "");
		subcategory = subcategory;
	}

	$.ajax({
		localCache: true,
		cacheTTL: 0.5,
		url: url + "&page=" + page,
		beforeSend: function () {
			if (page == 1) {
				$(pos + " .liveHorizontalListVideo").addClass('preloadVideoBox');
				$(pos + " .horizontalVideoGrid").show();
			}
		},
		success: function (json) {
			let objJson = JSON.parse(json);
			if (isObjectEmpty(objJson.contents) === false) {

				objJson = objJson.contents;
				sliderLoadercheckVideo = 0;
                
				//controllo sia la lista di episodi del video e che sia >1, altrimenti la nascondo

				// $(pos + ' .slick-next').prop("disabled", false);
				$(pos + " .liveHorizontalListVideo").removeClass('preloadVideoBox');

				if (objJson.length == 0 && page == 1) {
					$(pos + " .horizontalVideoGrid").hide();
				} else {
					if (pos == "#video_episodes" && page == 1 && objJson.length == 1) {
						$(pos + " .horizontalVideoGrid").hide();
					} else {
						$(pos + " .horizontalVideoGrid").show();
					}

					for (let i = 0; i < objJson.length; i++) {
						k_number++;

						img_preview = objJson[i].image;
						if (objJson[i].category) {
							category = "#" + objJson[i].category;
						} else {
							category = "";
						}

						duration = "";
						type = "";
						detailsHtml = "";

						let iconCourse = '';
						if (objJson[i].course === true) {
							// iconCourse = '';
						}

						duration = objJson[i].duration;
						if (typeof (objJson[i].duration) !== 'number') {
							if (duration) {
								detailsHtml = "<div class='detailsTypeVideo'><span></span><span> " + duration + "</span></div>"
							}
						} else {
							if (objJson[i].type_content == 'collections' && duration > 1) {
								detailsHtml = "<div class='detailsTypeVideo'><span> " + type + "</span><span>" + iconCourse + " <i class='ri-play-circle-fill'></i> " + duration + "</span></div>";
							}
						}


						let liveNowBox = '';
                        if (objJson[i].type_element == 'live') {
                            detailsHtml = "<div class='detailsTypeVideo'>" + translate('LIVE') + "<span></span></div>";                            
                            if (objJson[i].livenow == 1) {
                                detailsHtml = '<span class="live-horizontal-livenow-label">' + translate('LIVE') + '</span>';
                            }
						}
						
						if (objJson[i].percent_seen >= 98) {
							percentView = 100;
						} else {
							percentView = objJson[i].percent_seen;
						}

						like_obj = '';
						views_obj = '';
						div_like_views = '';
						let contentToSave = (objJson[i].type_content == 'videos') ? 'video' : 'serie';

						tot_views = formatVideoViews(objJson[i].total_views);
						if ((companyShowVideoViewThumb == 1 || companyShowVideoViewThumb == true)) {
							views_obj = '<div class="div-views"><span class="likes-label white">' + tot_views + ' ' + translate('VIEWS') + '</span></div>';
                            div_like_views = '<div class="box-like-views">' + views_obj + '</div>';
						}

						div_lock = '';
						label_courses = '';
						span_percent = '';
						progressPercent = 0;
						serieIsE = $('#seriesIsEnabled').val();


						extra_dots = "";
						title = objJson[i].title;
						if (title.length > 60) {
							extra_dots = "...";
						}

						let hideTitleClass = "";
						//hide thumn case
						if (companyThumbShowTitle == false) {
							hideTitleClass = "hidden";
						}

						let urlContent = '';
						if (objJson[i].type_content == 'videos') {
							urlContent = "loadPageVideo("+objJson[i].id+");";
                            
						}
						if (objJson[i].type_content == 'collections') {
							// if (objJson[i].type_element == 'package') {
							// 	urlContent = "window.location ='../../../package?s=" + objJson[i].id + "'";
							// } else {
							urlContent = "openSerieThumb(" + objJson[i].id + ")";
							// }
						}

						let lastSeen = 0;
                        if (objJson[i].type_content == 'collections') {
							lastSeen = getVideoLastSeen(objJson[i].id, null);
                        }else{
                            lastSeen = getVideoLastSeen(null, objJson[i].id);
                        }


						let objForPopUpPreview = {
							id: objJson[i].id,
							trailer: objJson[i].trailer,
							title: objJson[i].title,
							description: objJson[i].description,
							age_restriction: objJson[i].age_restriction,
							year_production: objJson[i].year_production
						};
						let objForPopUpPreview2 = encodeURIComponent(JSON.stringify(objForPopUpPreview));

						let elNumbered = '';
						let tileNumbered = '';

						if (numbered == "show") {
							// classe NUOVA (ty-topn): il vecchio nome
							// top_n_number_tile è pesantemente overridato
							// dai CSS custom dei canali (badge colorati)
							elNumbered = '<div class="ty-topn"><span>' + k_number + '</span></div>';
							tileNumbered = 'tile_numbered';
						}

						let elCoverVertical = '';

						if (cover == "vertical") {

							if (objJson[i].image_vertical) {
								img_preview = objJson[i].image_vertical;
							}

							elCoverVertical = 'tile__box_vertical';
						}


						let hmtlPlayContent = "";
						let playNextVideo = "#";

						try {
							if (objJson[i].next_video_play.access == "ok") {
								playNextVideo = "/video?w=" + objJson[i].next_video_play.id;
							}
						} catch (error) {

						}

						hmtlPlayContent += '<div class="tile__start_watch"><a href="' + playNextVideo + '" class=""><span class="button-round tile_play_now"><i class="ri-play-fill"></i></span><span class="watch_now_span white">' + translate('WATCH_NOW') + '</span></a></div>';


						let lock_content = "";
						if (objJson[i].access != "ok") {
							lock_content = '<i class="tile_lock ri-lock-fill"></i>';
						}


                        hmtlPlayContent += `<div class="tile__reminder"><span onclick="event.stopPropagation();openModalSetSavedContent(${objJson[i].id},'${contentToSave}');" class="button-round reminder_${contentToSave}${objJson[i].id}"></span></div>`;
					

						if (objJson[i].type_content != 'videos') {
							hmtlPlayContent += `<div class="tile__info"><span flow="left" onclick="event.stopPropagation();openSerieThumb(${objJson[i].id});" class="button-round"><i class="ri-info-i"></i></span></div>`;
						}

						finalArray += `
                            <li>
                                <div 
                                data-contentValue="${objForPopUpPreview2}" 
                                class="content_id_${objJson[i].id} thumb_content_preview thumb_content_preview_${cover}" 
                                style="cursor:pointer;" 
                                onclick="${urlContent};"
                                >
                                ${div_lock}
                                <div class="tile tile__box ${tileNumbered} ${elCoverVertical}">
                                    ${elNumbered}
                                    ${liveNowBox}
                                    <div class="tile__media ">
                                    <img 
                                        attr-img-type="${cover}" 
                                        attr-img-standard="${objJson[i].image}" 
                                        attr-img-vertical="${objJson[i].image_vertical}" 
                                        class="tile__media_img" 
                                        loading="lazy" 
                                        src="${img_preview}"
                                        onerror="this.onerror=null;this.src='img/void1px.png';"
                                    >
                                    </div>
                                    <div class="tile__details ${classOpacity}"></div>
                                    <div class="tile_call_to_action"></div>
                                    ${detailsHtml}
                                    ${lock_content}
                                </div>
                                <div class='tile__additionaActions'>
                                    ${hmtlPlayContent}
                                </div>
                                <div class='tile__contentDetails ${hideTitleClass}'>
                                    <p onclick="${urlContent};" class='tile__title '>
                                    ${title}
                                    ${extra_dots}
                                    </p>
                                    <div class='extra__info'></div>
                                    <p class='tile__description'></p>
                                </div>
                                </div>
                                <div class="percentVideoProgress" style="width:${lastSeen}%;"></div>
                                ${div_like_views}
                            </li>
                            `;
					}



					$(pos + ' .slider-container').append(finalArray);

                    //new likes
					for (var k = 0; k < objJson.length; k++) {
						let contentToSave = (objJson[k].type_content == 'videos') ? 'video' : 'serie';
						checkIfContentIsSaved(objJson[k].id, contentToSave);
						// if(companyShowLikeVideo){
						// 	checkIfContentIsLiked(objJson[k].id, 'all_scr', objJson[k].total_likes);
						// }
					}


					if (page == 1) {

						setTimeout(function() { //fix for localstorage
							try {
								let currentSlid = document.querySelector(pos + ' .swiffy-slider');
								
								swiffyslider.initSlider(currentSlid);
	
								swiffyslider.onSlideEnd(currentSlid, function () {
									if (swiffyEndLoadMore.includes(pos)) {
										// console.log("no", page);
										return false;
									}
	
									page++;
									// console.log("test", page);
									getContentsHorizontal(url, page, pos, mode, numbered, cover);
								});
	
							} catch (e) {
								console.log(e);
							}
						}, 200);

					} else {

						if (objJson.length < 9) {
							swiffyEndLoadMore.push(pos);
						}
					}


				}
			}

			if (currentVideoId) {
				$('.content_id_' + currentVideoId).addClass('currentVideoStyleInVideo');
			}

		},
		error: function () {
			if (page == 1) {
				$(pos + " .horizontalVideoGrid").hide();
			}
			// swiperListCollection[pos].off('slideChange');
			swiffyEndLoadMore.push(pos);
			return false;
		}
	});
}



function truncateStringTxt(string, length) {
	if (string.length > length)
		return string.substring(0, length) + '...';
	else
		return string;
};

function getContentsVertical(url, divLiveInLive, idRequest) { // search
    
	//metto in pausa i video in background	
	let position = getUrlParameter("position", url);

	if (!position || position == undefined || position == null) {
		position = '';
	}

	if (getUrlParameter("page", url) == 1 && getUrlParameter("append", url) != 1) {
		currentStepLiveInLive = 1;
		semapWindowsScrollLiL = 0; // ?
		$(divLiveInLive).html('');
	}

	let urlSplit = url.split("?");
    // Override calls to get_video and get_collection
    if (url.includes("get_video")) {
        url = URL_API2 + "/contents/videos";
    } else if (url.includes("get_collection")) {
        url = URL_API2 + "/contents/collections";
    } else {
        url = URL_API2 + "/contents";
    }

    let queryStrings = urlSplit[1];
    if (queryStrings) {
        // Rimuove eventuali & iniziali
        queryStrings = queryStrings.replace(/^&+/, '');
        // Aggiunge il ? solo se ci sono effettivamente dei parametri
        if (queryStrings !== '') {
            url += '?' + queryStrings;
        }
    }
    // alert(url);
	// ? END override calls to get_video and get_collection


	$(divLiveInLive).append('<div id="loading_results_spinner" style="clear:left;" class="col-md-12 text-center"><svg id="" class="circularLoading" height="50" width="50"><circle class="path" cx="25" cy="25.2" r="19.9" fill="none" stroke-width="6" stroke-miterlimit="10" /></svg></div>');

	$.ajax({
		localCache: true,
		cacheTTL: 1,
		type: "GET",
		url: url,
		success: function (json) {
			$("#loading_results_spinner").remove();
			let objJson = JSON.parse(json);
			if (isObjectEmpty(objJson.contents) === false) {
				objJson = objJson.contents;

				if (objJson.length == 0 && getUrlParameter("page", url) == 1 && getUrlParameter("append", url) != 1) {
					$(divLiveInLive).html("<p class='white bold text-center'>" + translate("NO_RESULTS") + "</p>");
				} else {
					if (objJson.length < 9) {
						$(".searchSpecificLoadMore").hide();
					}

					for (let i = 0; i < objJson.length; i++) {
						let img_preview = objJson[i].image;
						let detailsHtml = "";
						let percentView = "";

						let url2 = url.substr(0, url.indexOf("?"));

						let duration = objJson[i].duration;

						var type = "";
						if (objJson[i].course == true || objJson[i].payment_type != null) {
							subscribe = "<i class='ri-lock-fill'></i>";
						} else {
							subscribe = "";
						}

						if (objJson[i].type_content == 'collections' && duration > 1) {
							detailsHtml = "<div class='detailsTypeVideo'><span> " + type + "</span><span><i class='ri-play-circle-fill'></i> " + duration + "</span></div>";
						} else {
							if (duration) {
								detailsHtml = "<div class='detailsTypeVideo'><span></span><span> " + duration + "</span></div>"
							}
						}



						// if (objJson[i].percentView >= 100) {
						// 	percentView = 100;
						// } else {
						// 	percentView = objJson[i].percentView;
						// }
						var title = objJson[i].title.substring(0, 100);

						//console.log(objJson[i].title+" video 1");
						let urlContent = '';
                        let lastSeen = 0;
						if (objJson[i].type_content == 'videos') {
							urlContent = "loadPageVideo("+objJson[i].id+");";
                            lastSeen = getVideoLastSeen(null, objJson[i].id);
						}
						if (objJson[i].type_content == 'collections') {
							urlContent = "openSerieThumb(" + objJson[i].id + ")";
                            lastSeen = getVideoLastSeen(objJson[i].id, null);
						}

                        var contentToSave = 'video';
						if (objJson[i].type_element == 'series' || objJson[i].type_element == 'package') {
							contentToSave = 'serie';
						}
                        
                        var hideTitleClass = '';
                        if (companyThumbShowTitle == false) {
							hideTitleClass = "invisible";
						}

						var html = `
                        <div class="col-xs-6 col-md-4 padding-0 thumb_content_preview">
                            <div class="tile tile__box" onclick="${urlContent};">
                            <div class="tile__media">
                                <img 
                                loading="lazy" src="${img_preview}"
                                onerror="this.onerror=null;this.src='img/void1px.png';"
                                >
                            </div>
                            ${detailsHtml}
                            </div>
                            <div class="percentVideoProgress" style="width:${lastSeen}%;"></div>
                            <div onclick="${urlContent};" class="vertical_tile__title ${hideTitleClass}">
                            ${title}
                            </div>
                        </div>
                        `;


						$(divLiveInLive).append(html);
                        checkIfContentIsSaved(objJson[i].id, contentToSave);

					}


					if (objJson.length > 8) {

						semapWindowsScrollLiL = 0;
						if (getUrlParameter("page", url) == 1) {
							var lastScrollTop = 0;

							$(document).off('scroll');
                            onscrolleventbackup_header();

							onscrolleventbackup = function () {

								$(document).scroll(function () {

                                    if(
                                        currentPageState[currentPageState.length-1].indexOf("search") !== -1 || 
                                        currentPageState[currentPageState.length-1].indexOf("saved") !== -1
                                    ){
                                        //do nothing
                                    }else{
                                        //non si trova in una delle pagine di ricerca quindi non effettuo il check scroll
                                        return false;
                                    }

									var st = $(this).scrollTop();

									if (semapWindowsScrollLiL == 0 && st > lastScrollTop) {
										currentStepLiveInLive++;
										var urlapi2 = replaceUrlParam(url, "page", currentStepLiveInLive);
										semapWindowsScrollLiL = 1;
										getContentsVertical(urlapi2, divLiveInLive, idRequest);
                                        // console.log(urlapi2);
									}
									lastScrollTop = st;
								});
							}

							onscrolleventbackup();


						}
					} else {
						// $(window).off('scroll');
					}
				}
			} else {
				return false;
			}
		},
		error: function () {
			$('#loading_results_spinner').hide();
			// $('.textResultsFor').append(": ", translate("NO_RESULTS"));
			return false;
		}
	});
}


function openSerieThumb(id, state = false) {
    // layer nello stack (state=true = ripristino dal back: layer già in cima)
    if(state == false){
        addPageToState('collection-'+id);
    }

    // pagina reale: il contenuto sostituisce la pagina precedente
    navigateToPage('collection');

	getInfoCollection(id);
}




function getSubcategories(id) {
	$(".res_subcategory").html("Wait...");

	$.ajax({
        localCache: true,
		cacheTTL: 0.5,
		url: URL_API + "/categories/?f=get_subcategories&category=" + id,
		cache: false,
		success: function (html) {
			var objJson = JSON.parse(html);
			if (objJson.length == 0) {
				$(".res_subcategory").html("Nothing");
			} else {
				$(".res_subcategory").html(
					'<p style="cursor:pointer;" id="" class="subcategorysel">All</p>'
				);

				for (var i = 0; i < objJson.length; i++) {
					$(".res_subcategory").append(
						'<p style="cursor:pointer;" id="' +
						objJson[i].id +
						'" class="subcategorysel">' +
						objJson[i].subcategory +
						"</p>"
					);
				}
				$(".subcategorysel").click(function () {
					filter_subcategory($(this).attr("id"), $(this).text());
					$(".pageHoverFilterCategories").hide();
				});
			}
		}
	});
}


function contact_box() {
	$.ajax({
		type: "POST",
		url: URL_SITO + "/function/contactBox",
		data: dataString,
		cache: false,
		success: function (html) {
			$(".div_chat_list").html(html);
		}
	});
}

function checkBoxID(id) {
	if ($("#" + id).is(":checked")) {
		$("#" + id).val("1");
	} else {
		$("#" + id).val("0");
	}
}

function search_users(
	volte,
	modalita,
	val,
	category,
	subcategory,
	citta,
	provincia,
	regione,
	nazione
) {
	$("#wait").show();
	var quanti = 20;
	$.ajax({
		url: "../../../funzioni/home_utenti.php?volte=" +
			volte +
			"&modalita=" +
			modalita +
			"&val=" +
			val +
			"&category=" +
			category +
			"&subcategory=" +
			subcategory +
			"&citta=" +
			citta +
			"&provincia=" +
			provincia +
			"&regione=" +
			regione +
			"&nazione=" +
			nazione,
		cache: false,
		success: function (html) {
			$(".cards").html(html);
			$("#wait").hide();

			if (!html.trim()) {
				$("#carica_altri").html("All values loaded");
			}
		}
	});
}


function replaceUrlParam(url, paramName, paramValue) {
	if (paramValue == null) paramValue = "";
	var pattern = new RegExp("\\b(" + paramName + "=).*?(&|$)");
	if (url.search(pattern) >= 0) {
		return url.replace(pattern, "$1" + paramValue + "$2");
	}
	return (
		url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue
	);
}


function userBan(id) {
	var dataString = "id=" + id;
	$.ajax({
		type: "POST",
		url: URL_API + "/user/?f=ban",
		data: dataString,
		cache: false,
		success: function (json) {
			//console.log(json);
			var objJson = JSON.parse(json);

			if (objJson.status == "ban_add") {
				open_notifications_toast("User banned", "rgba(220,20,60,0.9)");
				$('.userBan' + id).text(translate('UNLOCK'));
			} else {
				open_notifications_toast("Ban removed", "rgba(0, 194, 59, 0.8)");
				if (element == 'btn_block') {
					$('.userBan' + id).text(translate('BLOCK'));
				}
			}
		}
	});
}



function validateEmailInput(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

function saveSubscriberLead(email, company) {
	if (validateEmailInput(email)) {
		var referrerLink = document.referrer;
		var values =
			"email=" + email + "&idc=" + company + "&ref_link=" + referrerLink;
		$.ajax({
			url: "/app/api/v1/marketing/?f=add_contact",
			type: "post",
			data: values,
			success: function (response) {
				$("#subscriberEmailLead").val("");
				open_notifications_toast(
					translate("THANKS_FOR_YOUR_SUBSCRIPTION"),
					"rgba(0, 194, 59, 0.8)"
				);
			},
			error: function (jqXHR, textStatus, errorThrown) { }
		});
	}
}

function fancyTimeFormatAnalytics(time) {
	// Hours, minutes and seconds
	var hrs = ~~(time / 3600);
	var mins = ~~((time % 3600) / 60);
	var secs = time % 60;

	// Output like "1:01" or "4:03:59" or "123:03:59"
	var ret = "";

	if (hrs > 0) {
		ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
	}

	ret += "" + mins + ":" + (secs < 10 ? "0" : "");
	ret += "" + secs;
	return ret;
}

function secondsToHms(d) {
	d = Number(d);

	var h = Math.floor(d / 3600);
	var m = Math.floor((d % 3600) / 60);
	var s = Math.floor((d % 3600) % 60);

	return (
		("0" + h).slice(-2) + ":" + ("0" + m).slice(-2) + ":" + ("0" + s).slice(-2)
	);
}

function cleanText(text = null) {
	if (text) {
		// text = text.replace(/:( )?/g, '');
		text = text.replace(/<br\s*\/?>/gi, "\n");
		text = text.replace(/&#039;/gi, "'");
		/*text.replace("&amp;", "&");
		text.replace("&gt;", ">");
		text.replace("&lt;", "<");
		text.replace("&quot;", '"');
		text.replace("&#039;", "'")*/

	}
	return text;
}



function niceBytes(x) {

	var units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	let l = 0,
		n = parseInt(x, 10) || 0;
	if (n === 1) return '1 byte'

	while (n >= 1024 && ++l) {
		n = n / 1024;
	}
	//include a decimal point and a tenths-place digit if presenting 
	//less than ten of KB or greater units
	return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
}




function findGetParameter(name) {
	const url = window.location.search;
	name = name.replace(/[\[\]]/g, '\\$&');
	const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
	const results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/*

function horizontalGetNewValue(current, step){

	var multScreen=(window.screen.width * window.devicePixelRatio);
	console.log(current);


	console.log(window.screen.width); // 
	var finalCos = (step * multScreen);
	console.log($('.videoselectedOriginal').scrollX);
	console.log(current+"-"+finalCos + '(' + multScreen + ')');
	if(current>finalCos){
		return true;
	}else{
		return false;
	}

}

function horizontalGetNewValue(current, step){
		alert(1);
		var element = $(current).find($('.slick-next'));
		console.log(element);
		
			if($(element).hasClass('slick-disabled')){
				alert(true);
			}
		return true;

		

}

	/*
	($(current)).scroll(function() {
		console.log($(current).scrollLeft() +' '+$(document).width() +' '+ $(window).width());
		var calc = ($(window).width())*step;
		console.log("calc: "+ calc + ', step: '+ step);
	*/
//	if($(current).scrollLeft() >= calc)  {
//	}else{
//		return false;
//	}
//});
//}






function open_notifications_toast(message, backcolor,time=2000) {
    window.plugins.toast.showShortBottom(message);
}

function copyThis(val, event=null) {
	if(event){
		event.stopPropagation();
	}

	//console.log(val);
	var range = document.createRange();
	range.selectNode(val);
	window.getSelection().removeAllRanges(); // clear current selection
	window.getSelection().addRange(range); // to select text
	document.execCommand("copy");
	window.getSelection().removeAllRanges(); // to deselect

	$(val).attr('flow', 'down');
	$(val).attr('tooltip', 'Copied');
}

function copyThisHover(val) {
	$(val).attr('flow', 'down');
	$(val).attr('tooltip', 'Click to copy');
}

function urlify(text) {
	var urlRegex = /(https?:\/\/[^\s]+)/g;
	return text.replace(urlRegex, function (url) {
		return url;
	})
}

function escapeHtml(text) {
	'use strict';
	return text.toString().replace(/[\"&'\/<>]/g, function (a) {
		return {
			'"': '&quot;',
			'&': '&amp;',
			"'": '&#39;',
			'/': '&#47;',
			'<': '&lt;',
			'>': '&gt;'
		}[a];
	});
}

function decodeHTMLEntities(str) {
	if (str && typeof str === 'string') {
		// strip script/html tags
		str = str.toString().replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
		str = str.toString().replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
	}

	return str;
}





function readURL(input) {
	if (input.files && input.files[0]) {
		var reader = new FileReader();
		reader.onload = function (e) {
			$('.landing_upload_image').attr('src', e.target.result);
		}
		reader.readAsDataURL(input.files[0]);
	}
}

// !
function blockButtonVideo(idElem) {

	const checkId = document.getElementById("inserisci_evento");

	if (!checkId) {
		return false;
	}
	var varDisabled = false;
	if (idElem == 'multi-title' || idElem == 'multi-tarea') {
		varDisabled = checkDescriptionMulti();
	} else {
		varDisabled = checkDescription();
	}
	document.getElementById("inserisci_evento").disabled = varDisabled;
}

// !
function blockButton(idElem) {
	//console.log('entro '+idElem);
	if (idElem != 'multi-tarea') {
		var varDisabled = false;
		if (idElem == 'multi-title') {
			//console.log('eseguo multi');
			varDisabled = checkDescriptionMultiOrganize();
		} else {
			//console.log('eseguo normale');
			varDisabled = checkDescriptionOrganize(idElem);
		}

		var btnAddColl = document.getElementById("btn_add_coll");
		if (btnAddColl) {
			document.getElementById("btn_add_coll").disabled = varDisabled;
		}

		var btnAddPack = document.getElementById("btn_add_pack");
		if (btnAddPack) {
			document.getElementById("btn_add_pack").disabled = varDisabled;
		}
	}
}

function checkDescriptionMulti() {
	var disabled = false;
	var count = $('.multi-language-input-check').length;

	for (var i = 0; i < count; i++) {
		var str = $('.multi-language-input-check').eq(i).val();
		//console.log('str '+str);
		str = str.replace(/\s/g, '');
		if (str == '') {
			disabled = true;
		} else {
			disabled = false;
			/* 			for (var j = 0; j < count; j++) {
							var desc = $('.multi-language-tarea-check').eq(j).val();
							//console.log('desc '+desc);
							desc = desc.replace(/\s/g, '');
							if (desc==''){
								disabled= true;
							} else {
								disabled= false;
								break;
							}
						} */
			break;
		}
	}
	return disabled;
}

function checkDescriptionMultiOrganize() {
	var disabled = false;
	var count = $('.multi-language-input-check').length;
	for (var i = 0; i < count; i++) {
		var str = $('.multi-language-input-check').eq(i).val();
		str = str.replace(/\s/g, '');
		if (str == '') {
			disabled = true;
		} else {
			disabled = false;
			break;
		}
	}
	return disabled;
}




function generateRandomString() {
	return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}


function decodeHtmlString(html) {
	var txt = document.createElement("textarea");
	txt.innerHTML = html;
	return txt.value;
}

function isJson(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}




function shareThisElement(type, id) {

    let url = companyDomain;    
	if(type == "collection"){
       url +=  '/collection?s=' + id;
    }else if(type == "video"){
       url +=  '/video?w=' + id;
    }else if(type == "playlist"){
       url +=  '/playlist?id=' + id;
    }else{
        return false;
    }
	
    // Web: condivisione di sistema (Web Share API); fallback copia negli
    // appunti + toast. Su nativo resta il plugin socialsharing.
    if (window.TY_WEB || !(window.plugins && window.plugins.socialsharing)) {
        try {
            if (navigator.share) {
                navigator.share({ title: document.title, url: url }).catch(function () {});
            } else if (navigator.clipboard) {
                navigator.clipboard.writeText(url);
                try { window.plugins.toast.showShortBottom('Link copiato'); } catch (e) {}
            }
        } catch (e) {}
    } else {
        window.plugins.socialsharing.share(null, null, null, url);
    }

    var fireObj = {
        "share": {
            type: type,
            id: id
        }
    };
    setFirebaseAnalyticsEvent(fireObj);

}


$(document).on({
	'show.bs.modal': function () {
		var zIndex = 99999 + (10 * $('.modal:visible').length);
		$(this).css('z-index', zIndex);
		setTimeout(function () {
			$('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
		}, 0);
	},
	'hidden.bs.modal': function () {
		if ($('.modal:visible').length > 0) {
			// restore the modal-open class to the body element, so that scrolling works
			// properly after de-stacking a modal.
			setTimeout(function () {
				$(document.body).addClass('modal-open');
			}, 0);
		}
	}
}, '.modal');


function isObjectEmpty(object) {
	let isEmpty = true;
	for (keys in object) {
		isEmpty = false;
		break;
	}
	return isEmpty;
}




function textReplaceURLs(message) {
	if (!message) return;
	var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
	return message.replace(urlRegex, function (url) {
		var hyperlink = url;
		if (!hyperlink.match('^https?:\/\/')) {
			hyperlink = 'http://' + hyperlink;
		}
		return '<a class="white" href="' + hyperlink + '" target="_blank" rel="External URL"><u>' + url + '</u></a>'
	});
}


function escapeRegExp(string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function replaceAll(str, find, replace) {
	return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}






function readmoreCheckbox(el) {
	let el1 = el.attr('id');
	// console.log(el1);
	let el2 = '#' + el1 + ' .read-more__checkbox';

	let checked = $(el2).is(":checked")
	if (checked) {
		$(el2).removeAttr('checked');
	} else {
		$(el2).attr('checked', 'checked');
	}

}


function openModalPaymentPreview(idc=null){
	var full_url_api = '';

	if (idc) {
		full_url_api = URL_API+"/collection/?f=get_payment_preview&id=" + idc;
	} else {
		full_url_api = URL_API+"/collection/?f=get_payment_preview";
	}
	
	let options = 
	{
		"showImage": false
	};
	
    addPageToState('modal-mobile-subscribe');

    BSLight.ModalShow('#modal-mobile-subscribe');
    $('#modal-mobile-subscribe-unique').html('');
    getListPricing('#modal-mobile-subscribe-unique', full_url_api, options);
	
}


function getListPricing(el, url) {

    let arrayProductIapIds = [];

    $(el).html(`<div id="loading_results_spinner" class="col-md-12 text-center row" style="margin-top:10vh;"><svg class="circularLoading" height="50" width="50"><circle class="path" cx="25" cy="25.2" r="19.9" fill="none" stroke-width="6" stroke-miterlimit="10" /></svg></div>`);
	$.ajax({
		type: 'GET',
		async: true,
		url: url,
		async: true,
		success: function (json) {
			let objSeriesPremium = JSON.parse(json);
            console.log(JSON.stringify(objSeriesPremium));            

			if (objSeriesPremium.length > 0) {
                //ottengo gli id dei prodotti relativi allo iap e alla piattaforma di riferimento
				for (let z = 0; z < objSeriesPremium.length; z++) {
                    if (cordova.platformId == 'android') {
                        if(objSeriesPremium[z].store_payments.android){
                            arrayProductIapIds.push(objSeriesPremium[z].store_payments.android);
                        }
                    }
                    if (cordova.platformId == 'ios') {
                        if(objSeriesPremium[z].store_payments.ios){
                            arrayProductIapIds.push(objSeriesPremium[z].store_payments.ios);
                        }
                    }
				}
			}
            
            console.log("product",arrayProductIapIds);

            // arrayProductIapIds = ['subs_1408', 'pd_1', 'subs_test'] ; //debug
            if(arrayProductIapIds.length == 0){
                // se è 0 ritorno un messaggio dicendo che l'acquisto in app non è disponibile e di visitare il sito web.
                $(el).html(`<p class="white text-center">${translate('EXPLORE_CONTENT_ACCESS_OPTIONS_ON')} ${companyDomain}</p>`);
                return false;
            }

            $(el).html(`<p class="text-center">${translate('CHOOSE_THE_OFFER_AND_ACCESS')}</p>`);
            // qui ciclo i prodotti e creo il box relavivo ai prezzi

            //oggetto ios
            // [{"productId":"subs_4Weeks","title":"4Weeks","description":"Tutto il catalogo WeShort, per un mese.","price":"4,00 €","priceRaw":"4","priceAsDecimal":4,"currency":"EUR","country":"IT","introductoryPrice":[null],"introductoryPriceSupported":true,"introductoryOriginalPrice":"4,00 €","introductoryOriginalPriceAsDecimal":4},{"productId":"subs_4Seasons","title":"4Seasons","description":"Tutto il catalogo WeShort, per un anno.","price":"24,00 €","priceRaw":"24","priceAsDecimal":24,"currency":"EUR","country":"IT","introductoryPrice":[null],"introductoryPriceSupported":true,"introductoryOriginalPrice":"24,00 €","introductoryOriginalPriceAsDecimal":24}]
            //  ${ products[i].introductoryPriceSupported && products[i].introductoryPrice[0].subscriptionPeriod.unit ? `<label class="label label-green">${convertStringDaysPlayStore(products[i].introductoryPrice[0].subscriptionPeriod.unit)} ${translate('FREE')}</label>` : ``}

            inAppPurchases.getAllProductInfo(arrayProductIapIds).then(function (products) {
                console.log(JSON.stringify(products));
                if(products.length==0){
                    $(el).html(`<p class="white text-center">${translate('EXPLORE_CONTENT_ACCESS_OPTIONS_ON')} ${companyDomain}</p>`);
                    return false;
                }
                for (let i = 0; i < products.length; i++) {
                    // access product information
                    // update your app to show store pricing
                    console.log(JSON.stringify(products[i]));
                    //faccio append
                    $(el).append(`
                        <div class="pa-2 card card-bordered mt-1 flex-col" onclick="linkPaymentIapPreview('${products[i].productId}');">
                            <p class="white xbold">${products[i].title}</p>
                            ${products[i].description ? `<p class="gray" style="font-size:14px;">${products[i].description}</p>`:``}
                            <h2 class="white xbold">${ products[i].introductoryOriginalPrice ? `${products[i].introductoryOriginalPrice}` : `${products[i].price}`}</h2>
                        </div>
                    `);
                    }

            }).catch (function(err){
                // view or handle error messages
                console.log(JSON.stringify(err));
            });
		}
	});
}


function convertStringDaysPlayStore(stringaDurata) {
    const match = stringaDurata.match(/^P(\d+)([YMWD])$/);
    if (!match) return null;

    const quantita = parseInt(match[1]);
    const unita = match[2];

    let testoUnitaSingolare, testoUnitaPlurale;
    switch (unita) {
        case 'Y':
            testoUnitaSingolare = translate('YEAR');
            testoUnitaPlurale = translate('YEARS');
            break;
        case 'M':
            testoUnitaSingolare = translate('MONTH');
            testoUnitaPlurale = translate('MONTHS');
            break;
        case 'W':
            testoUnitaSingolare = translate('WEEK');
            testoUnitaPlurale = translate('WEEKS');
            break;
        case 'D':
            testoUnitaSingolare = translate('DAY');
            testoUnitaPlurale = translate('DAYS');
            break;
        default:
            return "";
    }

    // Se la quantità è 1, restituisci il testo singolare, altrimenti il plurale
    const testoUnita = quantita === 1 ? testoUnitaSingolare : testoUnitaPlurale;
    return `${quantita} ${testoUnita}`;
}

function linkPaymentIapPreview(id){
    if(userData.status != 'success'){
        openModalLogin();
        return false;
    }
    startPayInApp(id);	
}


function userEventTracking(type,props) {

	var dataString = "properties=" + props;

	$.ajax({
		type: "POST",
		url: URL_API2 + '/events/'+type,
		data: dataString,
		cache: false,
		success: function (c) {

		}
	});
}


function chatColorStringMention(message) {
    var regex = /@\w+\b/g;
    var messageConColori = message.replace(regex, function(match) {
        return '<span style="color: #0283e7;">' + match + '</span>';
    });
    return messageConColori;
}

function checkIfContentIsSaved(id, type) {
    $(".reminder_" + type + id).html('<i class="ri-loader-4-line fx-spin"></i>');
    const checkUserDataStatus = () => {
        if (typeof userData !== 'undefined' && userData && userData.status !== undefined) {
            var find = false;
            if (userData.playlists) {
                for (const playlistId in userData.playlists) {
                    const playlist = userData.playlists[playlistId];
                    if (type === 'serie' && Array.isArray(playlist.collections) && playlist.collections.includes(id)) {
                        find = true;
                        break;
                    }
                    if (type === 'video' && Array.isArray(playlist.videos) && playlist.videos.includes(id)) {
                        find = true;
                        break;
                    }
                }
            }

            // var reminderTooltip = translate('SAVED');
            if (find) {
                $(".reminder_" + type + id).html(
                    '<i style="margin-right: 0;top: 0;" class="ri-check-line"></i>'
                );
            } else {
                // reminderTooltip = translate('REMIND_ME');
                $(".reminder_" + type + id).html(
                    '<i class="ri-add-line" style="margin-right: 0;top: 0;"></i>'
                );
            }
            // $(".reminder_" + type + id).attr('tooltip', reminderTooltip);
            clearInterval(intervalId);
        }
    };

    const intervalId = setInterval(checkUserDataStatus, 100);
}

function checkIfContentIsLiked(id, type=null, liketot = 0) {
	$(".like" + id).html('<i class="ri-loader-4-line fx-spin"></i>');
    const checkUserDataStatus = () => {
        if (typeof userData !== 'undefined' && userData && userData.status !== undefined) {
            var find = false;
            if (userData.liked) {
                if (Array.isArray(userData.liked) && userData.liked.includes(id)) {
                    find = true;
                }
            }
        
            var tot_likes = parseInt(liketot);
            if (tot_likes >= 1000000) {
                tot_likes = "+" + Math.floor(tot_likes / 1000000) + "M";
            } else if (tot_likes == 1000) {
                tot_likes = (tot_likes / 1000) + "K";
            } else if (tot_likes > 1000) {
                tot_likes = "+" + Math.floor(tot_likes / 1000) + "K";
            }

            if (find) {
                $(".like" + id).html('<i style="color:red !important;" class="ri-heart-fill"></i><label class="likes-label">' + tot_likes + '</label>');
            } else {
            	$(".like" + id).html('<i class="ri-heart-line"></i><label class="likes-label">' + tot_likes + '</label>');
            }
            clearInterval(intervalId);
        }
    };

    const intervalId = setInterval(checkUserDataStatus, 100); // Controlla ogni 100 millisecondi
}


function getUrlCallToAction(type) {
	try {
		let valType = type.split('-');
		if (valType[0] == 'serie') {
			openSerieThumb(valType[1]);
		} else if (valType[0] == 'video') {
            loadPageVideo(valType[1]);
		} else if (valType[0] == 'checkout') {
            if(valType[1]){
			    openModalPaymentPreview(valType[1]);
            }else{
                openModalPaymentPreview();
            }
		} else if (valType[0] == 'page' || valType[0] == 'link') {
            cordova.plugins.browsertabs.openUrlInBrowser(companyDomain+'/page?id_custom='+valType[1], onSuccessBrowserTabOpened, onErrorBrowserTabOpened);
		} else {
			
		}
	} catch (e) {
	}
}

function formatVideoViews(views) {
    views = parseInt(views);
    if (isNaN(views)) return '0';
    if (views >= 1000000) {
        return Math.floor(views / 1000000) + ' Mln';
    } else {
        return views.toString();
    }
}


function getVideoLastSeen(collectionId=null, videoId=null){
	try {
		if (userData.last_seen && userData.last_seen.length > 0) {

			if(videoId){
				const foundObjects = userData.last_seen.filter(obj => obj.video_id === videoId);
				if(foundObjects.length > 0){
					return foundObjects[0].percentage_view;
				}else{
					return 0;
				}
			}
			if(collectionId){
				const foundObjects = userData.last_seen.filter(obj => obj.collection_id === collectionId);
				if(foundObjects.length > 0){
					return foundObjects[0].percentage_view;
				}else{
					return 0;
				}
			}
		} else {
			return 0;
		}
	} catch (error) {
		return 0;
	}
}